import { render, staticRenderFns } from "./RoyComplexTable.vue?vue&type=template&id=4650f1ce&scoped=true&"
import script from "./RoyComplexTable.vue?vue&type=script&lang=js&"
export * from "./RoyComplexTable.vue?vue&type=script&lang=js&"
import style0 from "./RoyComplexTable.vue?vue&type=style&index=0&id=4650f1ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4650f1ce",
  null
  
)

export default component.exports